// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2g3Ey","title":"AfterBackImages_title__mQ8Cl","images":"AfterBackImages_images__1L56D"};